import { User } from "@/components/Types";
import { isBlank } from "../utils";

function isGuestUser(user: Partial<User> | null): boolean {
    let isGuest = false;

    if (!user) {
        return true;
    }

    if (isBlank(user.email) && isBlank(user.telegramId)) {
        isGuest = true;
    }

    return isGuest;
}

function isOnboardedUser(user: Partial<User> | null): boolean {
    if (!user) {
        return false;
    }

    let isOnboarded = false;

    if ((user.email || user.telegramId) && user.onboarded) {
        return true;
    } 

    return isOnboarded;
}

function shouldUserOnboardNow(user: Partial<User> | null): boolean {
    if (!user) {
        return false;
    }

    if (isGuestUser(user)) {
        return false;
    }

    return !isOnboardedUser(user);
}

export const usersDataTools = {
  isGuestUser,
  isOnboardedUser,
  shouldUserOnboardNow,
}